module.exports = __webpack_public_path__ + "img/背景.5026e14f.jpg";